import Head from 'next/head';

interface Props {
    category: string;
    /** Canonical path (without origin), e.g. "/coinflip" */
    path?: string;
}

const ORIGIN = 'https://rustyxbet.com';

const DESCRIPTION =
    'Get winning the most expensive rusty skin on the best site for Coinflip RUSTYXBET - ' +
    'using rust items with their inital value to take place in two possible games on best rust roulette site.';

const KEYWORDS =
    'rustyxbet, rustyxbet.com, rust skin, rust skin gambling, rust most expensive skin, ' +
    'rust skin sites, rust skin gambling sites, best cheap rust skin site, rust skin website, ' +
    'rust coinflip, rust skin coinflip, rust site coinflip, rust coinflip play, coinflip rust game, ' +
    'RUST jackpot, RUST jackpot game, RUST skin jackpot, how to win RUST skin, ' +
    'rust roulette, rust skin roulette, rust roulette sites, rust roulette play, how to win skin rust roulette';

const OG_IMAGE = `${ORIGIN}/og-cover.png`;

const SeoHead = ({ category, path }: Props) => {
    const title = `rustyxbet | ${category} | Rust Roulette Jackpot | rustyxbet.COM`;
    const url = path ? `${ORIGIN}${path}` : ORIGIN;

    return (
        <Head>
            <title>{title}</title>
            <meta name="description" content={DESCRIPTION} />
            <meta name="Keywords" content={KEYWORDS} />
            <meta name="robots" content="index, follow" />
            <link rel="canonical" href={url} />

            {/* Open Graph */}
            <meta property="og:type" content="website" />
            <meta property="og:site_name" content="rustyxbet.COM" />
            <meta property="og:title" content={title} />
            <meta property="og:description" content={DESCRIPTION} />
            <meta property="og:url" content={url} />
            <meta property="og:image" content={OG_IMAGE} />
            <meta property="og:locale" content="en_US" />

            {/* Twitter */}
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:title" content={title} />
            <meta name="twitter:description" content={DESCRIPTION} />
            <meta name="twitter:image" content={OG_IMAGE} />
        </Head>
    );
};

export default SeoHead;
